// extracted by mini-css-extract-plugin
export var cancelButton = "_q4-5";
export var content = "_q4-3";
export var createButton = "_q4-6";
export var drawerContainer = "_q4-0";
export var footer = "_q4-2";
export var header = "_q4-1";
export var orderFormColumn = "_q4-4";